import React from 'react';

const RentalAssetThumbType = () => {
    return (
        <div>

        </div>
    );
};

export default RentalAssetThumbType;